import React from 'react';
import MultipleSelector, { MulSelectorProps, SelectOptionWithGroup } from '../../MultipleSelector';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { AREAS, AREAS_NAMES_MAPPING } from '../constants';

import type { IArea } from '../types';

interface IMultipleAreaSelectProps extends MulSelectorProps {
  value: IArea[];
  onConfirm: (payload: IArea[]) => void;
}

const MultipleAreaSelect: React.FC<IMultipleAreaSelectProps> = (props) => {
  const { formatMessage } = useIntlExtend();

  const { value: valueOuter, onConfirm } = props;

  const value = Array.isArray(valueOuter) ? valueOuter : [];

  const areasOptions: SelectOptionWithGroup[] = AREAS.map((item) => {
    const translateKey = AREAS_NAMES_MAPPING?.[item];

    return {
      text: formatMessage({ id: translateKey }),
      value: item,
    };
  });

  const handleAreasChange = (payload: IArea[]) => {
    const sortedAreas = payload?.sort((a, b) => {
      const aIdx = AREAS.findIndex((item) => item === a);
      const bIdx = AREAS.findIndex((item) => item === b);
      return aIdx - bIdx;
    });
    onConfirm(sortedAreas ?? []);
  };

  return (
    <MultipleSelector
      hasAllCheck
      buttonName={formatMessage({ id: 'dbi_area_region' })}
      options={areasOptions}
      value={value}
      onChange={handleAreasChange}
    />
  );
};

export default MultipleAreaSelect;
